<div class="page-title">Welcome!</div>
Find info about the Game and rules in the <b>Game</b> menu and find your characters in the <b>Collection</b> menu
